import { createSelector } from 'reselect';
import { highlightTotalSavingsBasketSelector } from 'selectors/testTarget/offers/highlightTotalSavingsBasket/highlightTotalSavingsBasketSelector';

const experienceSelector = createSelector(highlightTotalSavingsBasketSelector, highlightTotalSavingsBasket => highlightTotalSavingsBasket.experience);

export { experienceSelector };
